module.exports = __webpack_public_path__ + "img/paper-clip-pencil.2902217f.svg";